var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12"},[(!_vm.isLoaded)?_c('div',{staticClass:"text-center"},[_c('GenericLoadingSpinner')],1):_c('div',[_c('pre',[_vm._v(_vm._s(_vm.rawEvent))])])])])}
var staticRenderFns = []

export { render, staticRenderFns }